module.exports = __webpack_public_path__ + "img/bg9.9ae643c1.png";